<script type="text/javascript">
    // 定义一些公共的属性和方法
    const httpUrl = './api'
    // const AESKey=

    function aesEncrypt(word) {
        var keyStr = 'i49KndYMEcvzBp2hPS4hkaQWYKEXMd51'; //判断是否存在ksy，不存在就用定义好的key
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return encrypted.toString();
    }


    import CryptoJS from 'crypto-js';
    // 暴露出这些属性和方法
    export default {
        httpUrl,
        aesEncrypt
    }
</script>


// WEBPACK FOOTER //
// src/common.vue